module.exports = __webpack_public_path__ + "static/hero-8cea841afb0d59798890fdb1314ae90d.jpg";